import { Activity, Footprints, Mountain, Wind, Flame, Anchor, Dumbbell } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type ExerciseIconKey =
  | 'core'
  | 'glutes'
  | 'cardio'
  | 'antirotation'
  | 'plank'
  | 'mobility';

interface IllustrationStyle {
  Icon: LucideIcon;
  iconClass: string;
  bgClass: string;
}

const STYLES: Record<ExerciseIconKey, IllustrationStyle> = {
  core: {
    Icon: Activity,
    iconClass: 'text-emerald-700',
    bgClass: 'bg-gradient-to-br from-emerald-100 via-emerald-50 to-white',
  },
  glutes: {
    Icon: Footprints,
    iconClass: 'text-amber-700',
    bgClass: 'bg-gradient-to-br from-amber-100 via-amber-50 to-white',
  },
  cardio: {
    Icon: Mountain,
    iconClass: 'text-rose-700',
    bgClass: 'bg-gradient-to-br from-rose-100 via-rose-50 to-white',
  },
  antirotation: {
    Icon: Anchor,
    iconClass: 'text-zinc-700',
    bgClass: 'bg-gradient-to-br from-zinc-200 via-zinc-100 to-white',
  },
  plank: {
    Icon: Wind,
    iconClass: 'text-emerald-700',
    bgClass: 'bg-gradient-to-br from-emerald-100 via-emerald-50 to-white',
  },
  mobility: {
    Icon: Flame,
    iconClass: 'text-amber-600',
    bgClass: 'bg-gradient-to-br from-amber-100 via-rose-50 to-white',
  },
};

interface ExerciseIllustrationProps {
  iconKey: ExerciseIconKey;
  size?: 'thumb' | 'hero';
}

export function ExerciseIllustration({
  iconKey,
  size = 'hero',
}: ExerciseIllustrationProps): JSX.Element {
  const style = STYLES[iconKey] ?? { Icon: Dumbbell, iconClass: 'text-emerald-700', bgClass: 'bg-emerald-50' };
  const sizeClass = size === 'thumb' ? 'size-7' : 'size-16 md:size-20';
  return (
    <div
      aria-hidden="true"
      className={`flex size-full items-center justify-center ${style.bgClass}`}
    >
      <style.Icon className={`${sizeClass} ${style.iconClass}`} strokeWidth={1.5} />
    </div>
  );
}
